import { Component, OnInit } from '@angular/core';
import { HomeInstagramService } from 'src/app/core/services/home-instagram.service';
import { HomeInstagramPayload, InstagramArticle } from 'src/app/models/home-instagram';

import Swal from 'sweetalert2';

@Component({
  selector: 'app-home-instagram',
  templateUrl: './home-instagram.component.html',
  styleUrls: ['./home-instagram.component.css']
})
export class HomeInstagramComponent implements OnInit {

  articulos: InstagramArticle[] = [];
  nuevaUrl: string = ''; // Para el input
  guardando: boolean = false;
  selectedFile: File | null = null;
  previewImage: string | null = null;


  constructor(private homeInstagramService: HomeInstagramService) { }

  async ngOnInit() {
    await this.cargarArticulos();
  }

  async cargarArticulos() {
    try {
      const data = await this.homeInstagramService.listarInstagram();

      this.articulos = (data.instagram || []).map((articuloRaw: any) => ({
        id: articuloRaw.id || articuloRaw.Id || '',
        url: articuloRaw.url || articuloRaw.Url || '',
        image: this.homeInstagramService.normalizarImagen(
          articuloRaw.image || articuloRaw.Image || ''
        ),
        title: articuloRaw.title || articuloRaw.titles?.main || articuloRaw.phrases?.main || ''
      }));


      console.log("📥 Artículos cargados desde endpoint:", this.articulos);

    } catch (error) {
      console.error('Error al cargar artículos:', error);
    }
  }


  private extraerUrlRelativa(url: string): string {
    try {
      const u = new URL(url);
      return u.pathname; // convierte a "/nacion/...-PPxxxx"
    } catch {
      return url; // fallback si ya es relativa
    }
  }

  async agregarArticulo() {
    if (!this.nuevaUrl) return;

    const match = this.nuevaUrl.match(/(PP\d+[A-Za-z]?)$/);
    console.log('prueba .match', this.nuevaUrl)
    if (!match) {
      Swal.fire({
        icon: 'warning',
        title: 'URL inválida',
        text: 'No se encontró el código del artículo en la URL',
        confirmButtonText: 'Aceptar'
      });
      return;
    }

    const id = match[1];

    try {
      const articuloRaw = await this.homeInstagramService.obtenerArticuloPorId(id);

      const articulo: InstagramArticle = {
        id,
        url: this.extraerUrlRelativa(this.nuevaUrl),
        // si hay imagen subida, úsala; sino la que viene del backend
        image: this.previewImage || this.homeInstagramService.normalizarImagen(
          articuloRaw.image || articuloRaw.Image || ''
        ),
        title: articuloRaw.title || articuloRaw.titles?.main || articuloRaw.phrases?.main || ''
      };

      this.articulos = [articulo, ...this.articulos];

      console.log("📋 Lista de artículos actualizada:", this.articulos);

      // limpiar estado de inputs después de añadir
      this.nuevaUrl = '';
      this.previewImage = null;
      this.selectedFile = null;

    } catch (error) {
      console.error('Error al agregar artículo:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No se pudo cargar el artículo',
        confirmButtonText: 'Cerrar'
      });
    }
  }



  eliminarArticulo(id: string) {
    this.articulos = this.articulos.filter(articulo => articulo.id !== id);
  }

  guardarCambios() {
    if (!this.articulos.length) {
      Swal.fire({
        icon: 'warning',
        title: 'Atención',
        text: 'No hay artículos para guardar',
        confirmButtonText: 'Aceptar'
      });
      return;
    }

    this.guardando = true;
    const payload: HomeInstagramPayload = { instagram: this.articulos };

    this.homeInstagramService.actualizarHomeInstagram(payload).subscribe({
      next: () => {
        Swal.fire({
          icon: 'success',
          title: 'Éxito',
          text: 'Cambios guardados correctamente',
          confirmButtonText: 'Aceptar'
        });
        this.guardando = false;
      },
      error: (err) => {
        console.error('Error al guardar cambios:', err);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Error al guardar cambios',
          confirmButtonText: 'Cerrar'
        });
        this.guardando = false;
      }
    });
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];
      this.uploadImage();
    }
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    if (event.dataTransfer?.files.length) {
      this.selectedFile = event.dataTransfer.files[0];
      this.uploadImage();
    }
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
  }

  async uploadImage() {
    if (!this.selectedFile) return;

    try {
      const formData = new FormData();
      formData.append('file', this.selectedFile);
      formData.append('app', 'RedaccionApp');

      const response: any = await this.homeInstagramService.uploadImage(formData);
      console.log('📦 Respuesta uploadFile:', response);

      // Solo guardamos el preview, sin tocar artículos todavía
      this.previewImage = response.path || response.url || response.fileUrl || '';

      Swal.fire({
        icon: 'success',
        title: 'Imagen subida',
        text: 'La imagen se cargó correctamente',
        confirmButtonText: 'Aceptar'
      });

    } catch (error) {
      console.error('Error al subir imagen:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No se pudo subir la imagen',
        confirmButtonText: 'Cerrar'
      });
    }
  }
}